// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-demo[data-v-7647f24a]{position:absolute;left:0;right:0;color:#fff;z-index:100;min-width:336px}.header-demo__inner[data-v-7647f24a]{padding-left:25px;padding-right:25px}.header-demo_logo_link[data-v-7647f24a]{display:block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
